import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, Card} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Column,Panel} from 'ktm-ui';

export default KTMScreen({name:"enroll.policy.activate-policy"}, class extends React.Component<{policy_id:string}> {

    data:{
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
        });
        screen.title = "Activate Policy";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Activate Policy"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Activate" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Card>
                <div>
                    <p>Activating a policy will create all employee balances.</p>
                    <p style={{ color: 'red', fontWeight: 'bold' }}>Have all employees been assigned a generated limit?</p>
                </div>
            </Card>
        );
    }

    async submit({screen}:ActionEvent){
        await KTMApi.action(screen,"submit",{
            "@policy_id":this.props.policy_id,
        });
        await screen.message("Policy activated.",{style:"success",asDialog:true});
        screen.close({"continue":true});
        window.location.replace("active.policy.browse");
    }

});
